import React, { Component } from 'react';
import { partnerApi, partnerDocupload } from  './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class Documents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 1,
      id_proof: '',
      qualification: '',
      user_img: '',
      id_proof_new: '',
      qualification_new: '',
      user_img_new: '',
      base_url: '',
      pid: ''
    }
    this.validator = new SimpleReactValidator({
      validators: {
        password_custome: {  // name the rule
          message: 'The :attribute must be a Min of 8 characters in length – One Capital Letter, One Number, One Character.',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        confirmpassword: {  // name the rule
          message: 'The :attribute must be Same as Password.',
          rule: (val, params, validator) => {
            if (val != this.state.password) {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        }
      }
    });

  }
  componentDidMount() {
    const { user_data } = this.state;
    if (this.state.authentication == true) {
      this.setState({
        user_type: user_data.user_type
      });
    }
    if (user_data.user_type == 2 && user_data.isSubpartner == false) {
      this.getDocs(user_data);
    }
  }
  getDocs = (user_data) => {
    console.log('user_data', user_data)
    let req = JSON.stringify({
      partner_id: user_data.login_id,
      url: 'getDocs',
      role: 3
    })
    partnerApi(req).then(res => {
      if (res.status === 1) {
        this.setState({
          id_proof: res.details.idproof_att,
          qualification: res.details.qualification_att,
          user_img: res.details.user_image_att,
          pid: res.details.pid,
          base_url: res.details.base_url
        })
      }
    })
  }
  handleFileChange = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };

  render() {
    this.validator.purgeFields();
    return (
      <React.Fragment>

    <div class="category_block">

    <div class="titleline">
      <h4>Documents</h4>
    </div>

        <form onSubmit={this.submitForm}>
          <div class="box-shadow-custom">
            <div className='row form-group'>
              <div className='col-md-6'>
                <label>Update ID proof</label>
                <input type='file' className='form-control' onChange={this.handleFileChange} name='id_proof_new' />
              </div>
              <div className='col-md-6'>
                {this.state.id_proof &&
                  <React.Fragment>
                    <label>Existing ID proof</label>
                    <br />
                    <b><a href={this.state.base_url + this.state.id_proof} target='_blank'>View</a></b>
                  </React.Fragment>
                }
              </div>
            </div>
            <div className='row form-group'>
              <div className='col-md-6'>
                <label>Update Qualification Certificate</label>
                <input type='file' className='form-control' onChange={this.handleFileChange} name='qualification_new' />
              </div>
              <div className='col-md-6'>
                {this.state.qualification &&
                  <React.Fragment>
                    <label>Existing Qualification Certificate</label>
                    <br />
                    <b><a href={this.state.base_url + this.state.qualification} target='_blank'>View</a></b>
                  </React.Fragment>
                }
              </div>
            </div>
            <div className='row form-group'>
              <div className='col-md-6'>
                <label>Update Profile</label>
                <input type='file' className='form-control' onChange={this.handleFileChange} name='user_img_new' />
              </div>
              <div className='col-md-6'>
                {this.state.user_img &&
                  <React.Fragment>
                    <label>Existing Profile</label>
                    <br />
                    <b><a href={this.state.base_url + this.state.user_img} target='_blank'>View</a></b>
                  </React.Fragment>
                }
              </div>
            </div>
          </div>
          <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
            <button type='submit' id="btnSubmit"
              className="btn btn-primary btn-sm">
              Save
            </button>
          </div>
        </form>

    </div>
    <NotificationContainer/>  
      </React.Fragment>

    );
  }
  submitForm = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const { user_type, login_id } = this.state.user_data;
      let request = {
        user_type: user_type,
        login_id: login_id,
        pid: this.state.pid,
        id_proof_new: this.state.id_proof_new,
        qualification_new: this.state.qualification_new,
        user_img_new: this.state.user_img_new,
      };
      partnerDocupload(request).then(res => {
        //let toastr = '';
        if (res.status === 1) {
          NotificationManager.success(res.message);
          //toastr = window.toastr.success;
          setTimeout(function () {
            window.location.reload();
          }, 2000)
        } else if(res.status === 2){
          NotificationManager.error(res.message);
          //toastr = window.toastr.warning;
        } else {
          NotificationManager.error(res.message);
          //toastr = window.toastr.error;
        }
        /*
        toastr(res.message, {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
        */
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
}

export default Documents;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/update_profile/document.jsx